export default __webpack_public_path__ + "static/media/XHighlight Logo.cdc0f395.png";